module.exports = {
    methods: {
        formatPrice(value, currency) {
            var moneyFormatter = new Intl.NumberFormat('da-DK', {
                style: 'currency',
                currency: currency,
                minimumFractionDigits: 0,
            });
            
            return moneyFormatter.format(value);
        },
    },
}